<template>
    <div class="input-group is-file" :class="{'is-dirty' : isDirty }">
        <div class="custom-file">
            <input ref="file" type="file" class="custom-file-input" :id="getFieldId" @change="updateValue($event)">
            <label class="custom-file-label overflow-hidden" :for="getFieldId" :aria-describedby="`inputGroupFile${getFieldId}`" v-text="__(getLabel)"></label>
            <label class="custom-file-name overflow-hidden" v-if="isDirty" v-text="__(fileName)"></label>
        </div>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        props: {
            value: {
                required: false,
            },
        },

        data() {
            return {
                input : this.value,
                isDirty: false,
                fileName: 'Choose file',
            }
        },

        methods: {
            updateValue() {
                this.isDirty = true
                this.fileName = this.$refs.file.files[0].name
                this.$emit('input', this.$refs.file.files[0])
            },
        },

        computed: {
            getLabel() {
                if (!this.floating && this.isDirty) return '';
                return this.label;
            }
        },
    }
</script>
